import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import WholesaleAssignSalesman from "../components/WholeSaleAssignSalesmanLayer";



const CategoryPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Assign Salesman" header="Assign Salesman" />

        {/* FormPageLayer */}
        <WholesaleAssignSalesman />


      </MasterLayout>

    </>
  );
};

export default CategoryPage;
